import { Button, Card, Typography } from "@hellocarbo/lasagne";
import { ArrowRight, LucideIcon } from "lucide-react";
import { ComponentProps, FC, SVGProps } from "react";

import UpsellModal from "./UpsellModal";

function ReviewCard({
  url,
  Icon,
  title,
  subtitle,
  buttonIntent = "primary",
  upsellModal,
}: {
  url: string;
  Icon: LucideIcon | FC<SVGProps<SVGSVGElement>>;
  title: string;
  subtitle?: string;
  buttonIntent?: ComponentProps<typeof Button>["intent"];
  upsellModal?: Omit<ComponentProps<typeof UpsellModal>, "children">;
}) {
  const ReviewCardLink = (
    <Button
      shape="soft"
      intent={buttonIntent}
      Icon={ArrowRight}
      as="a"
      href={url}
      size="small"
    />
  );

  return (
    <Card className="flex items-center justify-between">
      <div className="gap-x-sm flex items-center">
        <Icon className="size-md text-grayscale-light" />
        <div>
          <Typography weight="bold">{title}</Typography>
          {subtitle && (
            <Typography
              step="-1"
              weight="semibold"
              className="text-grayscale mt-3xs"
            >
              {subtitle}
            </Typography>
          )}
        </div>
      </div>
      {upsellModal ? (
        <UpsellModal {...upsellModal}>{ReviewCardLink}</UpsellModal>
      ) : (
        ReviewCardLink
      )}
    </Card>
  );
}

export default ReviewCard;
